var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.676,
    height: 10.303,
    viewBox: "0 0 11.676 10.303",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7293",
    "data-name": "Group 7293",
    transform: "translate(-0.465 -0.322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7019",
    "data-name": "Group 7019",
    transform: "translate(2.291 0) rotate(16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    d: "M7.913,0,.848,1.223A1.465,1.465,0,0,1,0,2.656L.516,5.635S1.528,5.445,1.8,6.728L8.866,5.5c-.174-1.3.843-1.461.843-1.461L9.193,1.064A1.465,1.465,0,0,1,7.913,0Z",
    transform: "matrix(0.985, 0.174, -0.174, 0.985, 1.168, 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445",
    transform: "matrix(0.985, 0.174, -0.174, 0.985, 2.975, 2.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M3.25,2.105.456,2.589A.11.11,0,0,1,.328,2.5L0,.613A.11.11,0,0,1,.091.486L2.886,0a.11.11,0,0,1,.127.09L3.34,1.978A.11.11,0,0,1,3.25,2.105ZM.526,2.354,3.1,1.907,2.815.237.237.684Z",
    transform: "translate(0 0)",
    fill: "#217dfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_444",
    "data-name": "Group 444",
    transform: "matrix(0.985, 0.174, -0.174, 0.985, 7.439, 1.29)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_262",
    "data-name": "Rectangle 262",
    width: 0.47,
    height: 0.47,
    transform: "matrix(0.985, -0.171, 0.171, 0.985, 0, 0.08)",
    fill: "#217dfb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_263",
    "data-name": "Rectangle 263",
    width: 0.47,
    height: 0.47,
    transform: "matrix(0.985, -0.171, 0.171, 0.985, 0.154, 0.969)",
    fill: "#217dfb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_264",
    "data-name": "Rectangle 264",
    width: 0.47,
    height: 0.47,
    transform: "matrix(0.985, -0.171, 0.171, 0.985, 0.308, 1.858)",
    fill: "#217dfb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_265",
    "data-name": "Rectangle 265",
    width: 0.47,
    height: 0.47,
    transform: "matrix(0.985, -0.171, 0.171, 0.985, 0.462, 2.747)",
    fill: "#217dfb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_266",
    "data-name": "Rectangle 266",
    width: 0.47,
    height: 0.47,
    transform: "matrix(0.985, -0.171, 0.171, 0.985, 0.616, 3.636)",
    fill: "#217dfb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_267",
    "data-name": "Rectangle 267",
    width: 0.47,
    height: 0.47,
    transform: "matrix(0.985, -0.171, 0.171, 0.985, 0.77, 4.525)",
    fill: "#217dfb"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.ef5b6ae176158225e7da83815ca06133.svg";
export { ForwardRef as ReactComponent };